import { Navigate, useLocation, useParams } from 'react-router-dom';

/**
 * Old detail route `/conversations/:id`. Verläufe opens every chat through
 * URL parameters now (`?c=<id>`, `?contact=…`, `?call=…`) — on the phone as
 * a full-screen chat over the list, so "back" returns to the list with its
 * filters and scroll position. Links and bookmarks to the old route land
 * there; other parameters (e.g. `focus=composer`) are kept.
 */
export default function ConversationDetailPage() {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  if (id && /^\d+$/.test(id)) params.set('c', id);
  const search = params.toString();
  return <Navigate to={`/conversations${search ? `?${search}` : ''}`} replace />;
}
